import { Equipment, GymType, TrainingEnvironment } from "@/constants/trainingEnvironment";

export interface EquipmentInterface {
    shortcut: Equipment;
    environment: TrainingEnvironment;
}

export const wholeHomeEquipment = [
    {
        shortcut: Equipment.PullUps,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.JumpRope,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.Kettlebell,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.Barbell,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.Dumbbells,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.PowerBand,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.SwissBall,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.WheelRoll,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.Roller,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.LoopBand,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.YogaMat,
        environment: TrainingEnvironment.Home,
    },
    {
        shortcut: Equipment.PlyoBox,
        environment: TrainingEnvironment.Home,
    },
];
const smallGymsEquipment = [
    {
        shortcut: Equipment.PullUps,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.JumpRope,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.LowerBackBench,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.Kettlebell,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.Barbell,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.Dumbbells,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.PowerBand,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.Bench,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.SwissBall,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.WheelRoll,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.Roller,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.LoopBand,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.YogaMat,
        environment: TrainingEnvironment.Gym,
    },
    {
        shortcut: Equipment.PlyoBox,
        environment: TrainingEnvironment.Gym,
    },
];

const equipmentByGymType: Record<GymType, EquipmentInterface[]> = {
    [GymType.Large]: [
        {
            shortcut: Equipment.Roller,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.SwissBall,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.ChestPress,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.CrossoverCableMachine,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.YogaMat,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.LowerBackBench,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.LegPress,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.EzBar,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.PullUps,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.Bench,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.LatMachine,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.LegCurlMachine,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.PowerBand,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.TrapBar,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.Dumbbells,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.JumpRope,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.Kettlebell,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.LoopBand,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.Landmine,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.Rack,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.PulleyMachine,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.PlyoBox,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.WheelRoll,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.LegExtension,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.InclineBench,
            environment: TrainingEnvironment.Gym,
        },
        {
            shortcut: Equipment.Barbell,
            environment: TrainingEnvironment.Gym,
        },
    ],
    [GymType.Garage]: smallGymsEquipment,
    [GymType.Small]: smallGymsEquipment,
    [GymType.Home]: smallGymsEquipment,
};

const getEquipment = (
    environment: TrainingEnvironment,
    gymType: GymType = GymType.Small
): EquipmentInterface[] => {
    if (environment === TrainingEnvironment.Home) return [];
    return equipmentByGymType[gymType];
};

export default getEquipment;
